import {
	call, put, takeEvery,
} from "redux-saga/effects";
import {
	ActionsBrandList,
	failureBrandList,
	loadBrandListSuccess,
	loadGetBrandList,
} from "./actions";
import Env from "../../../consts/env";

function* loadDataBrandList() {

	try {

		yield put(loadGetBrandList());

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getBrandList`;
		const headers = { ...Env.HEADERS };
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		const dataReview = yield response.json();

		if (response.status !== 200) {

			yield put(failureBrandList(yield response.statusText));

		} else {

			yield put(loadBrandListSuccess(yield dataReview));

		}

	} catch (err) {

		yield put(failureBrandList(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsBrandList.GET_BRAND_LIST, loadDataBrandList);

}
